<template>
    <div class="relative" :class="[sizeClass, padding]">
        <div
            class="absolute inset-0 transition-colors duration-200"
            :class="(isSelected ? 'bg-red-600' : borderColor) + ` ${cornerClass}`"
        ></div>

        <div
            v-if="imageSrc"
            :style="{
                backgroundImage: `url(${imageSrc})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
            }"
            class="absolute inset-[1px] transition-colors duration-200 [--cut-inset:0.586px]"
            :class="cornerClass"
        ></div>

        <div
            class="absolute inset-[1px] transition-colors duration-200 [--cut-inset:0.586px]"
            :class="[isSelected ? 'bg-red-700' : backgroundColor] + ' ' + bgClass + ' ' + cornerClass"
            :style="{
                opacity: imageSrc ? '.6' : '1',
            }"
        ></div>

        <div class="relative">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import imgGlass from '@images/setups/background.png?src'

export default {
    name: 'Panel',
    props: {
        size: {
            type: String,
            default: 'md',
        },
        selected: {
            type: Boolean,
            default: false,
        },
        bg: {
            type: String,
            default: null,
        },
        bgClass: {
            type: String,
            default: '',
        },
        // A clip-* class for the cut corner(s), or false for a plain square panel.
        corners: {
            type: [String, Boolean],
            default: 'clip-left-corner',
        },
        borderColor: {
            type: String,
            default: 'bg-stroke-1',
        },
        backgroundColor: {
            type: String,
            default: 'bg-card',
        },
        padding: {
            type: String,
            default: 'p-6',
        },
    },
    computed: {
        sizeClass() {
            const sizes = {
                xs: 'w-24',
                sm: 'w-32',
                md: 'w-40',
                lg: 'w-48',
                full: 'w-full',
            }
            return sizes[this.size]
        },
        isSelected() {
            return this.selected
        },
        cornerClass() {
            return this.corners || ''
        },
        cornerStyle() {
            return {
                clipPath: 'polygon(15px 0, 100% 0, 100% 100%, 0 100%, 0 15px)',
            }
        },
        imageSrc() {
            return this.bg ? imgGlass : null
        },
    },
}
</script>
